// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-icon[data-v-22d5927d]{cursor:pointer;color:#6c757d}.action-icon[data-v-22d5927d]:hover{opacity:.8}", ""]);
// Exports
module.exports = exports;
